import React from "react";
import { useAppState } from "../../StateStore/Store";

import {
  Card,
  CardContent,
  CardHeader,
  List,
  Inline,
  Checkbox,
  FormGroup,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@digitalreality/ui";
import { useForm } from "react-hook-form";
import { AppTypes } from "../../Helpers/Constants";
import { CheckboxCheckedIcon, CloseFilledIcon, LockIcon } from "@digitalreality/ui-icons";
import { t } from "i18next";
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

export default function DataProviders({ onSubmit, formRef }: any) {
    const { state } = useAppState();
    const { handleSubmit } = useForm({ mode: "onBlur", defaultValues: state.projectModal.project});

    const addSnowHeightDataProvider = (isactive: boolean, type: string, name: string, identification: string, needsLicense: boolean) => {
        var title = "";
        if (type === "IconTracking") { if (name != undefined) { title = "ConX " + name; } else { title = "ConX"; }}
        if (type === "Arena") { if (name != undefined) { title = "Arena " + name; } else { title = "Arena"; }}
        if (type === "FlatEarth") { if (name != undefined) { title = "Flat Earth " + name; } else { title = "Flat Earth"; }}
        if (type === "SnowSat") { if (name != undefined) { title = "SnowSat " + name; } else { title = "SnowSat"; }}

        return (
            <List>
                <ListItem sx={{ padding: '0'}}>
                    <ListItemIcon sx={{ minWidth: '36px'}}>
                        {needsLicense ? <LockIcon color="disabled" /> : isactive ? <CheckboxCheckedIcon color="success" /> : <CloseFilledIcon color="disabled" />}
                    </ListItemIcon>
                    <ListItemText>{title}</ListItemText>
                </ListItem>
                {needsLicense ?
                    <ListItem sx={{ padding: '0'}}><ListItemText sx={{ width: "350px" }} primary={<Typography style={{ fontSize: '12px', color: "#888888" }}>Interface license missing</Typography>}/></ListItem> :
                    isactive ?
                        <ListItem sx={{ padding: '0'}}><ListItemText sx={{ width: "350px" }} primary={<Typography style={{ fontSize: '12px', color: "#888888" }}>{identification}</Typography>}/></ListItem> :
                        <ListItem sx={{ padding: '0'}}><ListItemText sx={{ width: "350px" }} primary={<Typography style={{ fontSize: '12px', color: "#888888" }}>Not setup</Typography>}/></ListItem>
                }
                <Divider />
            </List>
        );
    };

    const addVehicleTrackingInterface = (isactive: boolean, type: string, name: string, count: number, needsLicense: boolean) => {
        var title = "";
        if (type === "IconTracking") { if (name != undefined) { title = "ConX " + name; } else { title = "ConX"; }}
        if (type === "MixTelematics") { if (name != undefined) { title = "Mix Telematics " + name; } else { title = "Mix Telematics"; }}

        return (
            <List>
                <ListItem sx={{ padding: '0'}}>
                    <ListItemIcon sx={{ minWidth: '36px'}}>
                        {needsLicense ? <LockIcon color="disabled" /> : isactive ? <CheckboxCheckedIcon color="success" /> : <CloseFilledIcon color="disabled" />}
                    </ListItemIcon>
                    <ListItemText>{title}</ListItemText>
                </ListItem>
                {needsLicense ?
                    <ListItem sx={{ padding: '0'}}><ListItemText sx={{ width: "350px" }} primary={<Typography style={{ fontSize: '12px', color: "#888888" }}>Interface license missing</Typography>}/></ListItem> :
                    count > 0 ? 
                        <ListItem sx={{ padding: '0'}}><ListItemText sx={{ width: "350px" }} primary={<Typography style={{ fontSize: '12px', color: "#888888" }}>Vehicles: {count}</Typography>}/></ListItem> :
                        <ListItem sx={{ padding: '0'}}><ListItemText sx={{ width: "350px" }} primary={<Typography style={{ fontSize: '12px', color: "#888888" }}>Not setup</Typography>}/></ListItem>
                    }
                <Divider />
            </List>
        );
    };

    const addSnowMakingInterface = (isactive: boolean, type: string, name: string, count: number, needsLicense: boolean) => {
        return (
            <List>
                <ListItem sx={{ padding: '0'}}>
                    <ListItemIcon sx={{ minWidth: '36px'}}>
                        {needsLicense ? <LockIcon color="disabled" /> : isactive ? <CheckboxCheckedIcon color="success" /> : <CloseFilledIcon color="disabled" />}
                    </ListItemIcon>
                    <ListItemText>{name}</ListItemText>
                </ListItem>
                {needsLicense ?
                    <ListItem sx={{ padding: '0'}}><ListItemText sx={{ width: "350px" }} primary={<Typography style={{ fontSize: '12px', color: "#888888" }}>Interface license missing</Typography>}/></ListItem> :
                    count > 0 ? 
                        <ListItem sx={{ padding: '0'}}><ListItemText sx={{ width: "350px" }} primary={<Typography style={{ fontSize: '12px', color: "#888888" }}>Snowguns: {count}</Typography>}/></ListItem> :
                        <ListItem sx={{ padding: '0'}}><ListItemText sx={{ width: "350px" }} primary={<Typography style={{ fontSize: '12px', color: "#888888" }}>Not setup</Typography>}/></ListItem>
                }
                <Divider />
            </List>
        );
    };

    return (
        <form
            id="interfaceForm"
            onSubmit={handleSubmit(onSubmit)}
            ref={formRef}
            autoComplete="off">
            <FormGroup>
                <Inline sx={{ width: "1292px", overflow: 'auto'}} gap={2}>
                    <Card sx={{ height: "538px", width: "400px", p: 0}}>
                        <CardHeader title="Snow data"/>
                        <Divider />
                        <CardContent sx={{ height: "490px", maxHeight: "490px", overflow: 'auto'}}>
                            {state.projectModal.dataconnections?.snowheightdataproviders?.map((app) => { return addSnowHeightDataProvider(app.isactive, app.type, app.name, app.identification, app.needsinterfacelicense) })}
                        </CardContent>
                    </Card>
                    <Card sx={{ height: "538px", width: "400px", p: 0}}>
                        <CardHeader title="Vehicle data"/>
                        <Divider />
                        <CardContent sx={{ height: "490px", maxHeight: "490px", overflow: 'auto'}}>
                        {state.projectModal.dataconnections?.vehicletrackingdataproviders?.map((app) => { return addVehicleTrackingInterface(app.isactive, app.type, app.name, app.vehiclescount, app.needsinterfacelicense) })}
                        </CardContent>
                    </Card>
                    <Card sx={{ height: "538px", width: "400px", p: 0}}>
                        <CardHeader title="Snow production"/>
                        <Divider />
                        <CardContent sx={{ height: "490px", maxHeight: "490px", overflow: 'auto'}}>
                        {state.projectModal.dataconnections?.snowmakingdataproviders?.map((app) => { return addSnowMakingInterface(app.isactive, app.type, app.name, app.snowgunscount, app.needsinterfacelicense) })}
                        </CardContent>
                    </Card>
                    <Card sx={{ height: "538px", width: "400px", p: 0}}>
                        <CardHeader title="Other"/>
                        <Divider />
                        <CardContent sx={{ height: "490px", maxHeight: "490px", overflow: 'auto'}}>
                            <List>
                                <ListItem sx={{ padding: '0'}}>
                                        <ListItemIcon>
                                            <Checkbox
                                            edge="start"
                                            disableRipple
                                            inputProps={{ 'aria-labelledby': "sa" }}
                                            />
                                        </ListItemIcon>
                                    <ListItemText primary={`Land registry Austria`} />
                                </ListItem>
                            </List>
                        </CardContent>
                    </Card>
                </Inline>
                <Typography sx={{ mt: '18px', mb: '0'}} style={{ fontSize: '12px', color: "#888888" }}>If you need further assistance setting up a connection or activating a license, please contact <a href="mailto:lmc.support@leica-geosystems.com" style={{ color: "#ffffff", textDecoration: 'none', marginLeft: '5px' }}>lmc.support@leica-geosystems.com</a></Typography>
            </FormGroup>
        </form>
    );
}
